module.exports = __webpack_public_path__ + "static/img/sl-banner.7546c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sl-banner.png
// module id = mk7a
// module chunks = 34